import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
  gap: ${dimens.SPACING_S};
`

export const FlexJS = styled(Flex)`
  justify-content: flex-start;
`

export const FlexStart = styled(Flex)`
  justify-content: flex-start;
  align-items: flex-start;
`

export const FlexAS = styled(Flex)`
  align-items: flex-start;
`

export const FlexAC = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`

export const FlexJC = styled(Flex)`
  justify-content: center;
`
